<template>
  <div class="package-edit-form-container ml-10">
    <app-filter
      :filter-list="table_filter"
      default-label-width="100px"
      @search="search"
    />
    <div class="text-right">
      <el-button
        :loading="pull_btn_loading"
        size="mini"
        type="success"
        @click="onPullComponent"
      >同步</el-button>
      <el-button
        :loading="add_btn_loading"
        size="mini"
        type="primary"
        @click="onCreateComponent"
      >新建标题</el-button>
    </div>
    <app-table
      ref="app_table_ref"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getComponentList"
      :table-props="{
        'max-height': '450px',
      }"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-bind="dialog_config.props" :title="dialog_config.title" :visible.sync="dialog_config.is_show">
      <app-form
        v-if="dialog_config.is_show"
        ref="title_form_ref"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      >
        <template #custom="{ form_key }">
          <!-- 动态词包 -->
          <div v-if="form_key === 'name'">
            <el-link v-for="item in pageConfig.word_list" :key="item" type="primary" :underline="false" class="mr-10" @click="insertWord(item)">+{{ item }}</el-link>
          </div>
        </template>
      </app-form>
    </el-dialog>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import {
  getComponentListApi,
  pullComponentApi,
  deleteComponentApi,
  createComponentApi,
} from '@/api/tool/component';

export default {
  name: 'ComponentList',
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 模块表单配置 */
    formFields: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 分配的标题组件数据 */
    assignSelection: {
      type: Array,
      default() {
        return [];
      },
    },
    /** 标题配置 */
    pageConfig: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        page_size: 10,
      },
      /** 同步按钮loading */
      pull_btn_loading: false,
      /** 新建按钮loading */
      add_btn_loading: false,
      /** 新增/编辑弹窗配置 */
      dialog_config: {
        is_show: false,
        title: '新增',
        id: null,
        props: {
          width: '500px',
          appendToBody: true,
        },
        form_config: {},
        confirm: () => {},
      },
    };
  },
  methods: {
    /**
     * 刷新表格
     * @returns {void}
     */
    refreshTable() {
      this.$refs['app_table_ref'].seekTable();
    },
    /**
     * 搜索
     * @param {Object} params 过滤参数
     * @returns {void}
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.refreshTable();
    },
    /**
     * 获取组件列表接口
     * @param {Object} params 接口参数
     * @returns {Promise<Object>}
     */
    getComponentList(params) {
      return new Promise((resolve, reject) => {
        const { name, ...rest } = params;
        const { channel_interface } = this.getInitConfig();
        const filtering = {
          ...(name && { name }),
        };
        getComponentListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          filtering,
          ...rest,
        })
          .then((res) => {
            res.list.forEach((item) =>
              Object.assign(item, {
                advertiser_id: this.advertiserId,
                title_component_type: 'component',
                delete_btn_loading: false,
              })
            );
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 同步组件列表
     * @returns {void}
     */
    onPullComponent() {
      this.pull_btn_loading = true;
      const { channel_interface } = this.getInitConfig();
      pullComponentApi({
        channel_interface,
        advertiser_id: this.advertiserId,
      })
        .then((res) => {
          this.$message.success(res.message || '同步成功');
          this.$refs['app_table_ref'].seekTable();
        })
        .finally(() => {
          this.pull_btn_loading = false;
        });
    },
    /**
     * 删除组件
     * @param {Object} row 组件数据
     * @returns {void}
     */
    onDeleteComponent(row) {
      this.$confirm('是否删除当前已选中的标题？', row.name, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        row.delete_btn_loading = true;
        this.handleDeleteComponent(row.id)
          .then(({ message }) => {
            this.$message.success(message || '删除成功');
            this.$refs['app_table_ref'].seekTable();
          })
          .finally(() => {
            row.delete_btn_loading = false;
          });
      });
    },
    /**
     * 处理删除组件
     * @param {number} id 组件ID
     */
    handleDeleteComponent(id) {
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        deleteComponentApi(id, {
          channel_interface,
          advertiser_id: this.advertiserId,
        })
          .then(resolve)
          .catch(reject);
      });
    },
    /**
     * 创建标题文案组件
     * @returns {void}
     */
    onCreateComponent() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新建标题组件',
        form_config: require('@/views/auxiliary/title/model/form-config')(this),
        confirm: (params) => {
          this.$refs['title_form_ref'].isLoading = true;
          this.handlerCreateComponent(params.name).then((res) => {
            this.$message.success(res.message || '创建成功');
            this.refreshTable();
            this.dialog_config.is_show = false;
          }).finally(() => (this.$refs?.['title_form_ref']?.isLoading && (this.$refs['title_form_ref'].isLoading = false)));
        },
      });
      this.addNameFieldRule();
    },
    /**
     * 处理创建组件
     * @param {Object} params 组件参数
     * @returns {void}
     */
    handlerCreateComponent(component_value) {
      const { channel_interface } = this.getInitConfig();
      const data = {
        channel_interface,
        advertiser_id: this.advertiserId,
        component_type: 'description',
        component_value,
      };
      return new Promise((resolve, reject) => {
        createComponentApi(data)
          .then(resolve)
          .catch(reject);
      });
    },
    /**
     * 设置标题表单规则
     * @returns {void}
     */
    addNameFieldRule() {
      const { getUseWordCount, rules } = this.pageConfig;
      const { name } = this.dialog_config.form_config;
      const rule = {
        required: true,
        validator: (rule, value, callback) => {
          if (rules.use_word_limit && getUseWordCount(value) > rules.use_word_limit) {
            callback(new Error(rule.message));
          } else {
            callback();
          }
        },
        message: `最多能使用${rules.use_word_limit}个动态词包`,
        trigger: ['change'],
      };
      name.rules[name.rules.length] = rule;
    },
    /**
     * 替换词包模板
     * @param {string} template 词包模板
     * @param {string} value 值
     * @returns {string}
     */
    replaceContext(template, value) {
      return template.replace(/context/g, value);
    },
    /**
     * 单个编辑/新增插入动态词包
     * @param {string} word 词包
     */
    insertWord(word) {
      const { name } = this.dialog_config.form_config;
      name.value += this.replaceContext(this.pageConfig.word_template, word);
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     * @returns {void}
     */
    selectionChange(rows) {
      this.assignSelection.splice(0);
      this.assignSelection.push(...rows);
    },
    /**
     * 获取初始化配置
     * @returns {Object}
     */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error) {
        console.log(error);
        return {};
      }
    },
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      return Promise.resolve(this.assignSelection);
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const list = this.formFields.selection_config.list.filter(
        (item) => {
          return String(item.advertiser_id) === String(this.advertiserId) && item.title_component_type === 'component';
        }
      );
      const app_table_ref = this.$refs.app_table_ref;
      this.assignSelection.splice(0);
      this.assignSelection.push(...list);
      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...this.assignSelection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...this.assignSelection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
  },
};
</script>
